import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'formatBoolean'
})
export class FormatBoolean implements PipeTransform {
  transform(
    value: boolean,
    nullIsFalse = false,
    yesLabel = 'Ja',
    noLabel = 'Nee'
  ) {
    return value
      ? yesLabel
      : value === false
      ? noLabel
      : value == null && nullIsFalse
      ? noLabel
      : '';
  }
}
